module.exports = __webpack_public_path__ + "img/bb_m_2_fr.1a616400.jpg";